import React from 'react';
import SearchPage from '../Pages/Search';
import Favorite from '../Pages/Favorite';

const Page404 = React.lazy(() => import('../Pages/404'));
const Main = React.lazy(() => import('../Pages/Main'));
const Login = React.lazy(() => import('../Pages/Login'));
const Admin = React.lazy(() => import('../Pages/Admin'));
const Basket = React.lazy(() => import('../Pages/Basket'));
const OrderConfirmation = React.lazy(
    () => import('../Pages/OrderConfirmation')
);
const AddProduct = React.lazy(
    () => import('../Pages/Admin/Products/AddProduct/index')
);
const AddPatterns = React.lazy(
    () => import('../Pages/Admin/Patterns/AddPatterns')
);
const Categories = React.lazy(() => import('../Pages/Categories'));
const AdminNewsEdit = React.lazy(
    () => import('../Pages/Admin/EditPublication')
);
const AdminNewsList = React.lazy(() => import('../Pages/Admin/Publications'));
const Directory = React.lazy(() => import('../Pages/Admin/Directory'));
const Publication = React.lazy(() => import('../Pages/Publication'));
const PublicationItem = React.lazy(() => import('../Pages/PublicationItem'));
const Product = React.lazy(() => import('../Pages/Product'));

const ListRoutes = [
    { element: <Page404 />, path: '*', private: false },
    { element: <Main />, path: '/', private: false },
    {
        element: <Categories />,
        path: '/categories/:categoryKey',
        private: false,
    },
    { element: <Product />, path: '/product/:id', private: false },
    { element: <Basket />, path: '/basket', private: false },
    { element: <Favorite />, path: '/favorite', private: false },
    {
        element: <OrderConfirmation />,
        path: '/order-confirmation/:personType',
        private: false,
    },
    { element: <Login />, path: '/login', private: false, layoutEmpty: true },
    {
        element: <Admin />,
        path: '/admin/:type?/:categoryId?/:table?',
        private: true,
    },
    { element: <Publication />, path: '/publication/:type', private: false },
    { element: <SearchPage />, path: '/search', private: false },
    {
        element: <PublicationItem />,
        path: '/publication/:type/:id',
        private: false,
    },
    { element: <Directory />, path: '/admin/directory/:name', private: true },
    {
        element: <AddPatterns />,
        path: '/admin/directory/pattern/:id',
        private: true,
    },
    {
        element: <AddProduct />,
        path: '/admin/product/:category?/:id?/:step?',
        private: true,
    },
    {
        element: <AdminNewsEdit />,
        path: '/admin/publication/:category/:id',
        private: true,
    },
    {
        element: <AdminNewsList />,
        path: '/admin/publication/:category',
        private: true,
    },
];
export default ListRoutes;
